<template>
  <div class="table-menu">
    <ul class="c-float">
      <li
        :class="{ active: get_active_filter_name ===  'All'}"
        @click="changeFilter({
          name: 'All',
        })">
        {{ $t('all') }}
      </li>
      <li
        v-for="(menuItem, index) in get_filters_menu"
        :key="`filterMenuItem-${index}`"
        :class="{ active: get_active_filter_name ===  menuItem.name}"
        @click="changeFilter({
          name: menuItem.name,
          params: menuItem.params,
        })">
        {{ menuItem.name }}
      </li>
      <!-- New filter -->
      <li
        class="pointer"
        @click="createNewFilter">+ {{ $t('Create New') }}</li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';

export default {
  name: 'TableMenu',
  props: {
    filterOptions: {
      type: Object,
      required: true,
    },
    tableActions: String,
  },
  data() {
    return {
      activeFilter: 'All',
    };
  },
  computed: {
    ...mapGetters([
      'get_active_filter_name',
      'get_active_filter',
      'get_search_term',
      // new data
      'get_filters_menu',
    ]),
  },
  methods: {
    createNewFilter() {
      this.$store.dispatch('SET_IS_CUSTOM_FILTER_NAME', true);
      this.$store.dispatch('SET_IS_NEW_FILTER', true);
      this.$emit('resetFilter');
      this.$store.dispatch('OPEN_SIDEBAR');
    },
    changeFilter(filter) {
      if (filter.name === 'All') {
        this.$store.dispatch('SET_IS_CUSTOM_FILTER_NAME', false);
        this.$store.dispatch('SET_IS_NEW_FILTER', false);
        this.$emit('resetFilter');
      } else {
        this.$store.dispatch('SET_IS_CUSTOM_FILTER_NAME', true);
        this.$store.dispatch('SET_IS_NEW_FILTER', false);
        this.$emit('startFilter', {
          filter,
          searchTerm: this.get_search_term,
        });
      }
      this.constructURL();
    },
    constructURL() {
      if (this.get_active_filter_name == 'All') {
        this.$router.push({
          path: this.$route.path,
        });
      } else {
        this.$router.push({
          path: this.$route.path,
          query: {
            search: JSON.stringify(this.get_active_filter),
            searchTerm: this.get_search_term,
          },
        });
      }
    },
  },
}
</script>
